import type { StateType } from '../../lib/types/state-type';
import type { FurnhomeCommunication } from '@dh-software/furnhome-communication';
import { chooseLanguage, setActiveLanguage } from '@dh-software/i18n';
import { setLoginContext } from '../../lib/login-context';

export async function checkSession(state: StateType, communication: FurnhomeCommunication): Promise<StateType> {
  const session = await communication.checkSession();

  // Kein Sprung zur Anmeldung: der OAuth-Server hat noch eine offene Sitzung und schickt sofort
  // zurueck - das ergaebe eine Endlosschleife.
  if (session.accessDenied) {
    // Die Sitzung besteht weiter, nur darf sie nichts. Name und Kundennummer gehen mit in den
    // State, damit die Leiste ueber der Sperrseite aussieht wie sonst.
    const deniedLanguage = chooseLanguage(session.locale);
    setActiveLanguage(deniedLanguage);

    return {
      ...state,
      loggedIn: false,
      customerNo: session.customerNo,
      userName: session.userName,
      loginLanguage: session.locale,
      language: deniedLanguage,
      allowedModules: [],
      page: 'forbidden',
    };
  }

  if (!session.authenticated) {
    window.location.href = communication.getLoginUrl(window.location.href);
    return state;
  }

  // Vor dem Wechsel auf 'workspace': erst danach wird ueberhaupt gezeichnet, die Oberflaeche
  // erscheint also gleich in der richtigen Sprache.
  const language = chooseLanguage(session.locale);
  setActiveLanguage(language);

  // Damit ein Modul fragen kann, wer da ist, ohne dafuer einen Request zu brauchen.
  setLoginContext({
    customerNumber: session.customerNo,
    userName: session.userName,
    contactId: /^\d+$/.test(session.contactId) ? Number(session.contactId) : null,
    locale: session.locale,
  });

  return {
    ...state,
    loggedIn: true,
    customerNo: session.customerNo,
    userName: session.userName,
    contactId: session.contactId,
    loginLanguage: session.locale,
    language: language,
    allowedModules: session.allowedModules,
    storeTree: session.storeTree,
    page: 'workspace',
  };
}
